import { useBlocker, useNavigate } from "react-router-dom";
import { EntityCardStore } from "./EntityCardStore";

export const useEntityNavBlocker = (store: EntityCardStore) => {
  const navigate = useNavigate();
  useBlocker(({ nextLocation }) => {
    if (store.isDirty) {
      store.setOnConfirm(() => navigate(nextLocation));
      return true;
    }
    return false;
  });
};
